import { c as _c } from "react/compiler-runtime";
import { getImageProps } from 'next/image';
import CardCarousel from '@classify/react-product-components/CardCarousel';
import PathDiscoveryItem from '@classify/react-product-components/PathDiscoveryItem';
import ProductMetadataDuration from '@classify/react-product-components/ProductMetadataDuration';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import ProductMetadataCertification from '@classify/react-product-components/ProductMetadataCertification';
import PathPromotionWrapper from './PathPromotionWrapper';
import { useCourseContext } from '../../_contexts/CourseContext';
const PathPromotion = () => {
  const $ = _c(9);
  const {
    recommendedPaths,
    hasActivePathSubscription
  } = useCourseContext();
  let t0;
  if ($[0] !== recommendedPaths) {
    t0 = recommendedPaths ?? [];
    $[0] = recommendedPaths;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const paths = t0;
  if (!paths || paths.length === 0 || hasActivePathSubscription) {
    return null;
  }
  const durationFullTimeMonths = _temp;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      previousArrowProps: {
        "data-event": "Slider|Clicked::Previous|Paths recommended for you"
      },
      nextArrowProps: {
        "data-event": "Slider|Clicked::Next|Paths recommended for you"
      }
    };
    t2 = {
      previousLabel: translate("global.word.go_back"),
      nextLabel: translate("global.word.go_to")
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== paths) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = pathItem => {
        if (!pathItem.illustration || !pathItem.title) {
          return null;
        }
        const {
          props
        } = getImageProps({
          alt: "",
          width: 288,
          height: 168,
          src: pathItem.illustration
        });
        return <PathDiscoveryItem key={pathItem.title} hasForcedRowLayout={true} link={pathItem.OpenClassroomsUrl} title={pathItem.title} field={pathItem.category?.name ?? ""} fieldColor={pathItem.category?.color ?? ""} description={pathItem.shortDescription ?? ""} thumbnail={props.src} data-event={`Slider|Clicked|Suggested paths::${pathItem.title}`}><Box sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4
          }}>{pathItem.certifications?.[0] && <ProductMetadataCertification key="PathCertification" accessibilityLabel={translate("paths.accessibility_labels.diploma")}>{pathItem.certifications[0].marketingLabel ?? ""}</ProductMetadataCertification>}{pathItem.duration && <ProductMetadataDuration key="duration" shouldNotWrap={true} duration={pathItem.duration} translations={{
              durationMonths: durationFullTimeMonths
            }} accessibilityLabel={translate("paths.accessibility_labels.duration")} />}</Box></PathDiscoveryItem>;
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = paths.map(t4);
    $[4] = paths;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <PathPromotionWrapper><CardCarousel slidesWidth="lg" sliderProps={t1} translations={t2}>{t3}</CardCarousel></PathPromotionWrapper>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default PathPromotion;
function _temp(count) {
  return translate("path_details.path_card.meta.full_time.months", {
    path_duration_months: count
  }, count);
}